module.exports = __webpack_public_path__ + "static/pytest-582ea3ca32a6e120c14f259c8e86448d.jpeg";